import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';

import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';

const infoscreenSwiper = new Swiper('.infoscreen', {
    autoplay: {
        delay: 20000,
        disableOnInteraction: false,
    },
    effect: 'fade',
    fadeEffect: {
        crossFade: true,
    },
    loop: true,
    speed: 1000,
    modules: [Autoplay, EffectFade],
});
infoscreenSwiper.on('reachEnd', function () {
	setTimeout(function(){
		location.reload();
	}, 20000); // 3000 milliseconds = 3 seconds
});
